import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.market.members');
import { normalizeMobile } from "src/libs/portal/season/contact-policy";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-ip-market-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.market.members/view.scss */
.ipt-members-page .ipt-members-filter, .ipt-members-page .ipt-members-list {
  border: 1px solid #dbe3ea;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.035);
}
.ipt-members-page .ipt-members-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;
  padding: 16px;
}
.ipt-members-page .ipt-members-filter__fields {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 10px;
}
.ipt-members-page .ipt-members-search {
  flex: 1;
  min-width: 220px;
  max-width: 360px;
}
.ipt-members-page input, .ipt-members-page select {
  width: 100%;
  height: 38px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  padding: 0 12px;
  color: #0f172a;
  font-size: 13px;
}
.ipt-members-page input:focus, .ipt-members-page select:focus {
  outline: 2px solid #67e8f9;
  outline-offset: 1px;
}
.ipt-members-page .ipt-members-select {
  width: 150px;
}
.ipt-members-page button {
  min-height: 38px;
  border-radius: 8px;
  padding: 0 15px;
  font-size: 12px;
  font-weight: 700;
}
.ipt-members-page button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
.ipt-members-page .ipt-members-primary {
  background: #0e7490;
  color: white;
}
.ipt-members-page .ipt-members-primary:hover:not(:disabled) {
  background: #155e75;
}
.ipt-members-page .ipt-members-refresh, .ipt-members-page .ipt-members-pagination button {
  border: 1px solid #cbd5e1;
  background: white;
  color: #475569;
}
.ipt-members-page .ipt-members-refresh:hover:not(:disabled), .ipt-members-page .ipt-members-pagination button:hover:not(:disabled) {
  background: #f1f5f9;
}
.ipt-members-page .ipt-members-list {
  overflow: hidden;
  margin-top: 16px;
}
.ipt-members-page .ipt-members-list__heading, .ipt-members-page .ipt-members-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px 18px;
}
.ipt-members-page .ipt-members-list__heading {
  border-bottom: 1px solid #e2e8f0;
}
.ipt-members-page .ipt-members-list__heading h2 {
  margin: 0;
  color: #0f172a;
  font-size: 15px;
  font-weight: 700;
}
.ipt-members-page .ipt-members-list__heading p, .ipt-members-page .ipt-members-list__heading > span, .ipt-members-page .ipt-members-footer {
  margin: 3px 0 0;
  color: #64748b;
  font-size: 12px;
}
.ipt-members-page .ipt-members-state {
  padding: 64px 18px;
  text-align: center;
  color: #64748b;
  font-size: 13px;
}
.ipt-members-page .ipt-members-state--error {
  color: #b91c1c;
}
.ipt-members-page .ipt-members-state--error button {
  margin-top: 12px;
  border: 1px solid #fca5a5;
  color: #b91c1c;
}
.ipt-members-page .ipt-members-table-wrap {
  max-width: 100%;
  overflow-x: auto;
}
.ipt-members-page .ipt-members-table {
  width: 100%;
  min-width: 880px;
  border-collapse: collapse;
  text-align: left;
  font-size: 12px;
}
.ipt-members-page .ipt-members-table th {
  padding: 13px 16px;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}
.ipt-members-page .ipt-members-table td {
  padding: 14px 16px;
  border-top: 1px solid #f1f5f9;
  color: #334155;
  white-space: nowrap;
}
.ipt-members-page .ipt-members-table tbody tr:hover {
  background: #f8fafc;
}
.ipt-members-page .ipt-members-name {
  color: #0f172a !important;
  font-weight: 700;
}
.ipt-members-page .ipt-members-status {
  display: inline-block;
  border-radius: 999px;
  padding: 4px 9px;
  font-size: 11px;
  font-weight: 700;
}
.ipt-members-page .ipt-members-status.is-active {
  background: #dcfce7;
  color: #166534;
}
.ipt-members-page .ipt-members-status.is-pending {
  background: #fef3c7;
  color: #92400e;
}
.ipt-members-page .ipt-members-status.is-suspended {
  background: #fee2e2;
  color: #991b1b;
}
.ipt-members-page .ipt-members-status.is-closed {
  background: #f1f5f9;
  color: #475569;
}
.ipt-members-page .ipt-members-footer {
  border-top: 1px solid #e2e8f0;
}
.ipt-members-page .ipt-members-pagination {
  display: flex;
  gap: 8px;
}
@media (max-width: 640px) {
  .ipt-members-page .ipt-members-filter__fields {
    width: 100%;
  }
  .ipt-members-page .ipt-members-search, .ipt-members-page .ipt-members-select {
    width: 100%;
    max-width: none;
  }
  .ipt-members-page .ipt-members-primary {
    flex: 1;
  }
  .ipt-members-page .ipt-members-refresh {
    width: 100%;
  }
}

.ipt-members-manage {
  border: 1px solid #cad8cf;
  border-radius: 8px;
  padding: 7px 12px;
  background: #fff;
  color: #175b39;
  font-weight: 600;
}

.ipt-members-detail-backdrop {
  position: fixed;
  inset: 0;
  z-index: 120;
  background: rgba(15, 35, 25, 0.35);
  display: flex;
  justify-content: flex-end;
}

.ipt-members-detail {
  background: #fff;
  width: min(560px, 100%);
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.12);
}

.ipt-members-detail__header {
  padding: 24px;
  border-bottom: 1px solid #e3e9e5;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.ipt-members-detail__header p {
  margin: 0 0 6px;
  color: #64766a;
  font-size: 13px;
}

.ipt-members-detail__header h2 {
  margin: 0;
  font-size: 23px;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.ipt-members-detail__header h2:focus {
  outline: none;
}

.ipt-members-detail button {
  cursor: pointer;
  min-height: 40px;
  padding: 8px 13px;
  border: 1px solid #cad8cf;
  border-radius: 8px;
  background: #fff;
  color: #234632;
}

.ipt-members-detail button:disabled {
  opacity: 0.5;
  cursor: default;
}

.ipt-members-detail button.ipt-members-primary {
  background: #176b3d;
  color: #fff;
  border-color: #176b3d;
}

.ipt-members-detail button.is-danger {
  color: #a52d35;
  border-color: #ebc8cc;
}

.ipt-members-detail__body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.ipt-members-detail__body h3 {
  margin: 0 0 16px;
  font-size: 17px;
}

.ipt-members-detail__summary {
  display: grid;
  grid-template-columns: 84px 1fr;
  gap: 14px 12px;
  padding: 0 0 24px;
  border-bottom: 1px solid #e3e9e5;
  margin: 0 0 24px;
}

.ipt-members-detail__summary dt {
  color: #66766b;
  font-size: 14px;
}

.ipt-members-detail__summary dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.ipt-members-detail__form {
  display: grid;
  gap: 10px;
  margin-bottom: 28px;
}

.ipt-members-detail__form input, .ipt-members-detail textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #bdccc2;
  border-radius: 8px;
  padding: 11px 12px;
  font-size: 15px;
}

.ipt-members-detail__form button {
  margin-top: 8px;
  justify-self: start;
}

.ipt-members-detail__account {
  padding-top: 24px;
  border-top: 1px solid #e3e9e5;
}

.ipt-members-detail__account p {
  color: #5a6c60;
  font-size: 14px;
  line-height: 1.7;
}

.ipt-members-detail__actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.ipt-members-detail__confirm {
  margin-top: 18px;
  padding: 16px;
  background: #f5f8f5;
  border: 1px solid #d6e2d9;
  border-radius: 10px;
}

.ipt-members-detail__confirm h4 {
  margin: 0 0 8px;
}

.ipt-members-detail__confirm label {
  display: block;
  margin: 12px 0 7px;
  font-size: 14px;
}

.ipt-members-detail__confirm .ipt-members-detail__actions {
  margin-top: 12px;
}

.ipt-members-detail__error, .ipt-members-detail__notice {
  padding: 12px;
  border-radius: 8px;
  line-height: 1.6;
}

.ipt-members-detail__error {
  color: #972d36;
  background: #fff2f3;
}

.ipt-members-detail__notice {
  color: #176b3d;
  background: #edf7ef;
}

@media (max-width: 600px) {
  .ipt-members-detail__header, .ipt-members-detail__body {
    padding: 20px 16px;
  }
}`],
})
export class PageIpMarketMembersComponent implements OnInit {
    public items: any[] = [];
    public loading = false;
    public error = '';
    public search = { q: '', status: '' };
    public page = 1;
    public total = 0;
    public totalPages = 0;
    public statuses = [
        { value: '', label: '전체 상태' },
        { value: 'ACTIVE', label: '활성' },
        { value: 'SUSPENDED', label: '이용 정지' },
        { value: 'CLOSED', label: '탈퇴' }
    ];

    public selected: any = null;
    public memberForm = { name: '', phone: '' };
    public detailLoading = false;
    public detailReady = false;
    private memberTrigger: HTMLElement | null = null;
    public saving = false;
    public memberError = '';
    public notice = '';
    public pendingStatus = '';
    public reason = '';
    public discardWarning = false;
    private detailSequence = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load(1);
    }

    public async load(page: number = this.page) {
        if (this.loading || page < 1) return;
        this.loading = true;
        this.error = '';
        await this.service.render();
        try {
            const response = await wiz.call('list_users', {
                page,
                q: this.search.q.trim(),
                status: this.search.status
            });
            if (response.code !== 200) {
                throw new Error(response.data?.error?.message || '회원 목록을 불러오지 못했습니다.');
            }
            const data = response.data || {};
            this.items = Array.isArray(data.items) ? data.items : [];
            this.page = data.pagination?.page || page;
            this.total = data.pagination?.total || 0;
            this.totalPages = data.pagination?.total_pages || 0;
        } catch (error: any) {
            this.items = [];
            this.total = 0;
            this.totalPages = 0;
            this.error = error?.message || '회원 목록을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public statusLabel(value: string) {
        const found = this.statuses.find((item) => item.value === value);
        return found ? found.label : (value || '-');
    }

    public statusClass(value: string) {
        if (value === 'ACTIVE') return 'is-active';
        if (value === 'PENDING_VERIFICATION') return 'is-pending';
        if (value === 'SUSPENDED') return 'is-suspended';
        return 'is-closed';
    }

    public formatDate(value: string) {
        if (!value) return '-';
        let timestamp = String(value).trim().replace(/^(\d{4}-\d{2}-\d{2}) /, '$1T');
        // Core's timezone-less SQL datetimes are UTC; never interpret them in the browser's zone.
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(timestamp)) timestamp += 'Z';
        const date = new Date(timestamp);
        if (Number.isNaN(date.getTime())) return '-';
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hour12: false
        }).format(date);
    }

    public get memberDirty() {
        return !!this.selected && (this.memberForm.name !== this.selected.name || this.memberForm.phone !== this.selected.phone);
    }

    public async openMember(item: any) {
        if (this.saving) return;
        if (this.memberDirty) { this.discardWarning = true; await this.service.render(); return; }
        if (!this.selected) this.memberTrigger = document.activeElement as HTMLElement;
        this.detailReady = false;
        const sequence = ++this.detailSequence;
        this.selected = { ...item };
        this.memberForm = { name: item.name || '', phone: item.phone || '' };
        this.detailLoading = true; this.memberError = ''; this.notice = '';
        this.pendingStatus = ''; this.reason = ''; this.discardWarning = false;
        await this.service.render();
        try {
            const response = await wiz.call('detail_user', { id: item.id });
            if (sequence !== this.detailSequence) return;
            if (response.code !== 200) throw new Error(response.data?.error?.message || '회원 정보를 불러오지 못했습니다.');
            this.selected = response.data;
            this.detailReady = true;
            this.memberForm = { name: this.selected.name || '', phone: this.selected.phone || '' };
        } catch (error: any) {
            if (sequence === this.detailSequence) this.memberError = error?.message || '회원 정보를 불러오지 못했습니다.';
        } finally {
            if (sequence === this.detailSequence) { this.detailLoading = false; await this.service.render(); document.getElementById('member-detail-title')?.focus(); }
        }
    }

    public async closeMember(discard = false) {
        if (this.saving) return;
        if (this.memberDirty && !discard) { this.discardWarning = true; await this.service.render(); return; }
        ++this.detailSequence; this.selected = null; this.discardWarning = false;
        const trigger = this.memberTrigger;
        this.memberTrigger = null;
        await this.service.render();
        if (trigger?.isConnected) trigger.focus();
        else (document.querySelector(".ipt-members-manage") as HTMLElement | null)?.focus();
    }

    public get memberInputValid(): boolean {
        const name = this.memberForm.name.trim();
        return !!name && name.length <= 50 && normalizeMobile(this.memberForm.phone) !== null;
    }

    public async saveMember() {
        if (!this.selected || this.saving || !this.detailReady || !this.memberDirty) return;
        this.memberError = ''; this.notice = '';
        const name = this.memberForm.name.trim(), phone = normalizeMobile(this.memberForm.phone);
        if (!name || name.length > 50 || phone === null) {
            this.memberError = '이름은 1~50자, 휴대전화는 010-0000-0000 형식으로 입력해 주세요.';
            await this.service.render(); return;
        }
        this.saving = true; await this.service.render();
        try {
            const response = await wiz.call('update_user', { id: this.selected.id, version: this.selected.version, name, phone });
            if (response.code !== 200) throw new Error(response.data?.error?.message || '회원 정보 저장에 실패했습니다.');
            this.selected = response.data;
            this.memberForm = { name: this.selected.name || '', phone: this.selected.phone || '' };
            this.notice = '회원 정보를 저장했습니다.';
            await this.load(1);
        } catch (error: any) { this.memberError = error?.message || '회원 정보 저장에 실패했습니다.'; }
        finally { this.saving = false; await this.service.render(); }
    }

    public async chooseStatus(status: string) {
        if (this.saving || !this.detailReady || this.memberDirty) return;
        this.pendingStatus = status; this.reason = ''; this.memberError = ''; this.notice = '';
        await this.service.render(); document.getElementById('member-status-reason')?.focus();
    }

    public async confirmStatus() {
        if (!this.selected || this.saving || !this.pendingStatus) return;
        const reason = this.reason.trim();
        if (!reason || reason.length > 500) { this.memberError = '변경 사유를 1~500자로 입력해 주세요.'; await this.service.render(); return; }
        this.saving = true; this.memberError = ''; await this.service.render();
        try {
            const response = await wiz.call('change_status', { id: this.selected.id, version: this.selected.version, status: this.pendingStatus, reason });
            if (response.code !== 200) throw new Error(response.data?.error?.message || '계정 상태 변경에 실패했습니다.');
            this.selected = response.data; this.pendingStatus = ''; this.reason = '';
            this.notice = '계정 상태를 변경했습니다.';
            await this.load(1);
        } catch (error: any) { this.memberError = error?.message || '계정 상태 변경에 실패했습니다.'; }
        finally { this.saving = false; await this.service.render(); }
    }

    public onDetailKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') { event.preventDefault(); void this.closeMember(); return; }
        if (event.key !== 'Tab') return;
        const panel = event.currentTarget as HTMLElement;
        const controls = Array.from(panel.querySelectorAll<HTMLElement>('button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), a[href]')).filter(el => el.offsetParent !== null);
        if (!controls.length) { event.preventDefault(); return; }
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement as HTMLElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
}

export default PageIpMarketMembersComponent;